import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject, input, output } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";

import { EnabledPipe } from "../../../../../helpers/enabledpipe/enabledpipe";
import { AuthService } from "../../../../../services/authservice";
import { SelfserviceToggle } from "../../../../selfservice/selfservice-toggle/selfservice-toggle";
import { Row } from "../../tabbed-detail-container.types";

@Component({
  selector: "configuration-details",
  templateUrl: "configuration-details.html",
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, EnabledPipe, MatTooltipModule, SelfserviceToggle, TranslatePipe],
})
export class ConfigurationDetails {
  protected auth = inject(AuthService);

  readonly configurationDetails = input.required<{ title: string; rows: Row[] }>();
  readonly firewallEnabled = input.required<boolean>();
  readonly isInfrastructureDelegate = input.required<boolean>();

  protected title = computed(() => this.configurationDetails().title);
  protected rows = computed(() => this.configurationDetails().rows);

  protected clicked = output<string>();

  private readonly bgpComponentMap = {
    BFD: { type: "bfd", tooltipKey: "Selfservice.Tooltip.BFD" },
    "Graceful restart": { type: "graceful-restart", tooltipKey: "Selfservice.Tooltip.GracefulRestart" },
  };

  protected onBgpComponentClick = (row: Row) => {
    const config = this.bgpComponentMap[row.title];
    if (config) {
      this.clicked.emit(config.type);
    }
  };

  protected getTooltipKey = (title: string) => this.bgpComponentMap[title]?.tooltipKey || "";
}
